import { keyframes } from "styled-components";

export const billboardImageAnimation = keyframes`
  0% {
    transform: scale(.7)
  }
  100% {
    transform: scale(1)
  }
`;

export const riseFadeIn = keyframes`
0%{
  opacity: 0;
}
100%{
  opacity: 1;
  transform: translateY(0);
}
`;

export const fadeInFadeOut = keyframes`
  0%{
  opacity: 0;
}
25%{
  opacity: 1
}
75%{
  opacity: 1
}
100%{
  opacity: 0;
}
`;

export const throughFloor = keyframes`
0%{
  transform: translateY(102%);
}
100%{
  transform: translateY(0);
}
`;

export const queryAnimation = keyframes`
  0%{
    opacity: 0
  }
  50%{
    opacity: 1
  }
  100%{
    opacity: 0
  }
`;

export const fadeIn = keyframes`
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
`;
